'use client';

import Link from 'next/link';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import * as LucideIcons from 'lucide-react';

interface HelpCategory {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  icon?: string | null;
  _count?: {
    articles: number;
  };
}

interface HelpCategoryGridProps {
  categories: HelpCategory[];
}

export function HelpCategoryGrid({ categories }: HelpCategoryGridProps) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {categories.map((category) => {
        // Dynamically get the icon component
        const IconComponent = category.icon
          ? (LucideIcons as any)[category.icon] || LucideIcons.HelpCircle
          : LucideIcons.HelpCircle;

        return (
          <Link
            key={category.id}
            href={`/help/${category.slug}`}
            className="transition-transform hover:scale-105"
          >
            <Card className="h-full cursor-pointer border-2 hover:border-primary hover:shadow-lg">
              <CardHeader>
                <div className="mb-2 flex items-center gap-3">
                  <div className="rounded-lg bg-primary/10 p-2">
                    <IconComponent className="h-6 w-6 text-primary" />
                  </div>
                </div>
                <CardTitle className="text-lg">{category.name}</CardTitle>
                {category.description && (
                  <CardDescription className="line-clamp-2">
                    {category.description}
                  </CardDescription>
                )}
              </CardHeader>
              {category._count && (
                <CardContent>
                  <p className="text-sm text-muted-foreground">
                    {category._count.articles} article{category._count.articles !== 1 ? 's' : ''}
                  </p>
                </CardContent>
              )}
            </Card>
          </Link>
        );
      })}
    </div>
  );
}
